module.exports = __webpack_public_path__ + "static/logo-4fc6516059328aaefa046536d4a42d47.svg";